var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodAndBeverage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons industries"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2188_99",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 40,
    height: 40,
    fill: "#3470E4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2188_99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "brunch_dining",
    d: "M4.16671 36.6668C3.91671 36.6668 3.71532 36.5904 3.56254 36.4377C3.40976 36.2849 3.33337 36.0835 3.33337 35.8335V33.3335H26.6667V35.8335C26.6667 36.0835 26.5903 36.2849 26.4375 36.4377C26.2848 36.5904 26.0834 36.6668 25.8334 36.6668H4.16671ZM3.33337 30.0002V27.5002C3.33337 27.2502 3.40976 27.0488 3.56254 26.896C3.71532 26.7432 3.91671 26.6668 4.16671 26.6668H11.6667V23.3335H18.3334V26.6668H25.8334C26.0834 26.6668 26.2848 26.7432 26.4375 26.896C26.5903 27.0488 26.6667 27.2502 26.6667 27.5002V30.0002H3.33337ZM30 36.6668V26.5002C29 25.3613 28.1945 24.2363 27.5834 23.1252C26.9723 22.0141 26.6667 20.6668 26.6667 19.0835V3.3335H36.6667V19.0835C36.6667 20.6668 36.3681 22.021 35.7709 23.146C35.1737 24.271 34.3612 25.3891 33.3334 26.5002V33.3335H36.6667V36.6668H30ZM30 13.3335H33.3334V6.66683H30V13.3335ZM31.6667 23.4168C32.1667 22.8335 32.5695 22.1668 32.875 21.4168C33.1806 20.6668 33.3334 19.8891 33.3334 19.0835V16.6668H30V19.0835C30 19.8891 30.1389 20.6668 30.4167 21.4168C30.6945 22.1668 31.1112 22.8335 31.6667 23.4168Z",
    fill: "#5D8DE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodAndBeverage);
export default __webpack_public_path__ + "static/media/Food-and-Beverage.aa7dd4ff5e99dbc8abc79d8fc663c495.svg";
export { ForwardRef as ReactComponent };